import styled from 'styled-components';

export const FilterSelect = styled.div`
  display: flex;
  flex-flow: row nowrap;
  width: 100%;
`;

export const TypeSelectContent = styled.div`
  cursor: pointer;
  width: 40%;
  border: none;
  border-right: 1px solid rgba(0, 0, 0, 0.1);
`;

export const ValueSelectContent = styled.div`
  width: 100%;
`;
